import { proxy } from 'valtio';

type OrgData = {
  id: string | undefined;
};

export const currentOrgData = proxy<OrgData>({
  id: undefined,
});

export const updateOrgId = (id: string) => (currentOrgData.id = id);
